// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountWidget_wrapper__Xz+Xj"};